import React, { useEffect, useState } from 'react';
import ProjectSection from './components/ProjectSection';
import WorkSection from './components/WorkSection';
import HeadingSection from './components/HeadingSection';
import TaskSection from './components/TaskSection';
import httpInjectorService from 'services/http-injector.service';

const AdminDashboard = () => {
  const [filters, setFilters] = useState({
    project_id: [],
    issue_type_id: [],
    status: [],
  });

  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch dashboard whenever filters change
  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        setLoading(true);

        const payload = {
          project_id: filters.project_id.length ? filters.project_id : undefined,
          issue_type_id: filters.issue_type_id.length ? filters.issue_type_id : undefined,
          status: filters.status.length ? filters.status : undefined,
        };

        const response = await httpInjectorService.getDashboardMetrics(payload);
        setDashboardData(response?.data);
      } catch (err) {
        console.error('Dashboard fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, [filters]);

  useEffect(() => {
    // Initial fetch with default filters
    const fetchInitialDashboard = async () => {
      try {
        setLoading(true);
        const response = await httpInjectorService.getDashboardMetrics();
        setDashboardData(response?.data);
      } catch (err) {
        console.error('Initial dashboard fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialDashboard();
  }, []);

  return (
    <>
     <div data-tour="dashboard-filters">
  <HeadingSection
    filters={filters}
    setFilters={setFilters}
  />
</div>

<div data-tour="project-metrics">
  <ProjectSection
    data={dashboardData}
    loading={loading}
  />
</div>

<div>
  <WorkSection
    data={dashboardData}
    loading={loading}
  />
</div>

<div data-tour="task-analytics">
  <TaskSection
    data={dashboardData}
    loading={loading}
  />
</div>
    </>
  );
};

export default AdminDashboard;